// import { useQuery } from '@tanstack/react-query';
import { usePrivy } from '@privy-io/react-auth';
import { useQuery } from '@tanstack/react-query';

import { publicApi } from '@/lib/api-clients/rest-client';
import { CapitalStatus } from '@/types';

type CapitalStatusData = {
  is_funded: boolean;
  capital_status: CapitalStatus;
  active_capital_plan: string | null;
  capital_activated_at: string | null; // ISO date string
};

export type CapitalStatusResponse = Record<string, CapitalStatusData>;

interface CapitalStatusParams extends Pick<Config, 'addresses'> {
  get_network_type?: boolean;
}

/**
 * Fetches the capital account status for the authenticated user
 * @param params.get_network_type - Optional boolean to include network type in response (default: false)
 * @returns Capital account status object
 */
export const getCapitalStatus = async (
  params: CapitalStatusParams,
): Promise<CapitalStatusResponse> => {
  const response = await publicApi.get<CapitalStatusResponse>(
    '/capital/status',
    {
      params: {
        address: params.addresses.join(','),
        get_network_type: params?.get_network_type ?? false,
      },
    },
  );

  return response;
};

type Config = {
  addresses: string[];
  refetchInterval?: number;
  onSuccess?: (res: CapitalStatusResponse) => void;
};

export default function useCapitalStatus(config: Config = { addresses: [] }) {
  const { authenticated } = usePrivy();
  return useQuery({
    enabled: config.addresses.length > 0 && authenticated,
    queryKey: ['capital/status', config.addresses],
    queryFn: ({ queryKey: [_, addresses] }) =>
      getCapitalStatus({ addresses: addresses as string[] }).then((res) => {
        config.onSuccess?.(res);
        return res;
      }),
    ...config,
  });
}

// export function useCapitalStatus(
//   params?: CapitalStatusParams,
//   options?: {
//     enabled?: boolean;
//     refetchInterval?: number;
//     refetchOnWindowFocus?: boolean;
//   },
// ) {
//   return useQuery({
//     queryKey: ['capital-status', params?.get_network_type],
//     queryFn: () => getCapitalStatus(params),
//     enabled: options?.enabled ?? true,
//     refetchInterval: options?.refetchInterval,
//     refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
//   });
// }
